<template>
  <div class="person-mask">
    <div class="person-mask__inner">
      <figure
        v-if="image?.image?.id"
        class="person-mask__image-focal-container"
      >
        <AppImageFocal :data="image" :renditions="renditions" :eager="true" />
      </figure>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  image: unknown,
}>()

const renditions = [
  {width: 383, height: 366, breakpoint: 'xs'},
]
</script>

<style scoped lang="postcss">
.person-mask {
  display: grid;
  width: 100%;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  &__inner {
    grid-column: 1 / -1;
    grid-row-start: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__image-focal-container {
    position: relative;
    width: 100%;
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-image: url('assets/svg/o.svg');
    min-height: 305px;
  }
}
</style>
